// 判断ua中是否有开启提审开关
function uaSwitchOn(ua) {
  const matches = ua.match(/\sSUB\/([\d])/);
  if (matches && matches[1] && Number(matches[1]) === 1) {
    return true;
  }
  return false;
}
/**
 * 判断所处浏览器环境
 * 注意只能在h5模式中使用
 */
export function checkEnv() {
  const ua = navigator.userAgent;
  return {
    isApp: /com\.tencent\.gamecommunity/.test(ua),
    mobile: /AppleWebKit.*Mobile.*/i.test(ua),
    ios: new RegExp('\\(i[^;]+;( U;)? CPU.+Mac OS X', 'i').test(ua),
    android: /Android/i.test(ua) || /Linux/i.test(ua),
    windowsphone: /Windows Phone/i.test(ua),
    iPhone: /iPhone/i.test(ua),
    iPad: /iPad/i.test(ua),
    iPadQQ: /IPadQQ/i.test(ua),
    webApp: !/Safari/i.test(ua),
    MicroMessenger: /MicroMessenger/i.test(ua),
    weibo: /Weibo/i.test(ua),
    toutiao: /NewsArticle/i.test(ua),
    uc: /UCBrowser/i.test(ua),
    qq: /MQQBrowser/i.test(ua),
    baidu: /Baidu/i.test(ua),
    /* eslint-disable-next-line */
    mqq: /QQ\/([\d\.]+)/i.test(ua),
    qComic: /\bcom\.tencent\.nijigen/i.test(ua),
    mbaidu: /baiduboxapp/i.test(ua),
    iqiyi: /iqiyi/i.test(ua),
    QQLive: /QQLive/i.test(ua),
    Safari: /Safari/i.test(ua),
    Youku: /youku/i.test(ua),
    wx: /(micromessenger|webbrowser)/i.test(ua),
    isDebug: /ENV\/DEBUG/i.test(ua),
    isTest: /ENV\/TEST/i.test(ua),
    isProd: /ENV\/RELEASE/i.test(ua),
    isSwitchOn: (/(iPad|iPhone|iPod)/).test(ua) && uaSwitchOn(ua), // ios提审开关
    isAndroidSwitchOn: (/Android/i.test(ua) || /Linux/i.test(ua)) && uaSwitchOn(ua), // 安卓提审开关,,
  };
}
